import { navItems, type AppRoute } from '../../app/navigation';
import './AppShell.css';

type AppShellProps = {
  activeRoute: AppRoute;
  onRouteChange: (route: AppRoute) => void;
  children: React.ReactNode;
};

export function AppShell({ activeRoute, onRouteChange, children }: AppShellProps) {
  return (
    <div className="app-shell">
      <Sidebar activeRoute={activeRoute} onRouteChange={onRouteChange} />
      <main className="app-main" id="main-content">
        {children}
      </main>
      <MobileNavigation activeRoute={activeRoute} onRouteChange={onRouteChange} />
    </div>
  );
}

function Sidebar({ activeRoute, onRouteChange }: Omit<AppShellProps, 'children'>) {
  return (
    <aside className="sidebar" aria-label="Primary navigation">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <div className="brand">
        <span className="brand-mark">B</span>
        <div>
          <div className="brand-name">Body</div>
          <div className="brand-tagline">Track less. Understand more.</div>
        </div>
      </div>
      <nav className="nav-list">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = item.route === activeRoute;
          return (
            <button
              key={item.route}
              className="nav-item"
              data-active={isActive}
              aria-current={isActive ? 'page' : undefined}
              onClick={() => onRouteChange(item.route)}
            >
              <Icon size={19} strokeWidth={2.1} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
}

function MobileNavigation({ activeRoute, onRouteChange }: Omit<AppShellProps, 'children'>) {
  return (
    <nav className="mobile-nav" aria-label="Primary navigation">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = item.route === activeRoute;
        return (
          <button
            key={item.route}
            className="mobile-nav-item"
            data-active={isActive}
            aria-current={isActive ? 'page' : undefined}
            onClick={() => onRouteChange(item.route)}
          >
            <Icon size={20} strokeWidth={2.2} />
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
